module.exports = __webpack_public_path__ + "img/couples-008.a48101ea.jpg";